import React from 'react';
import PropTypes from 'prop-types';
import Toggler from 'components/Toggler';
import {
  ButtonDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import { stringCompare } from 'lib/view-helpers';

function Dropdown({ title, items, onSelect, selected, ...rest }) {
  const select = (item) => (e) => {
    e.preventDefault();
    onSelect(item);
  };

  return (
    <Toggler>
      {(toggle, open) => (
        <ButtonDropdown isOpen={open} toggle={toggle}>
          <DropdownToggle caret {...rest}>
            {title}
          </DropdownToggle>
          <DropdownMenu>
            {items.map((item, index) => (
              <DropdownItem
                key={index}
                onClick={select(item)}
                active={stringCompare(item.id, selected)}>
                {item.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </ButtonDropdown>
      )}
    </Toggler>
  );
}

Dropdown.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  selected: PropTypes.string,
  onSelect: PropTypes.func
};

Dropdown.defaultProps = {
  title: '',
  items: []
};

export default Dropdown;
